(function ($) {
  /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */

  $.fn.visible = function (partial) {
    var $t = $(this),
      $w = $(window),
      viewTop = $w.scrollTop(),
      viewBottom = viewTop + $w.height(),
      _top = $t.offset().top,
      _bottom = _top + $t.height(),
      compareTop = partial === true ? _bottom : _top,
      compareBottom = partial === true ? _top : _bottom

    return compareBottom <= viewBottom && compareTop >= viewTop
  }

  $(document).ready(function () {
    $(".content-slider-container").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 6000,

      dots: true,
      // this is how we can do custom pagination images
      customPaging: function (slider, i) {
        // Define the SVG string for the pagination image
        var svgString =
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="4" viewBox="0 0 40 4" fill="none"><rect width="40" height="4" rx="2" fill="#181818" fill-opacity="0.1"/></svg>'
        // Create the HTML for the custom pagination SVG
        var customPagination = svgString

        return customPagination
      },
    })

    $element = $(".slide .feature")
  })
})(jQuery)
